import React from 'react';
import {Card} from "../../components/Card";

export default function StandardAdminBrowserLayout(props) {


    return <Card header={props.header ?? "Przeglądaj"} subHeader={props.subHeader}>
        {props.criteriaComponent}
        {props.resultsComponent}
        {props.paginationComponent}
    </Card>
}

StandardAdminBrowserLayout.propTypes = {

}

StandardAdminBrowserLayout.defaultProps = {

}